import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
 
// Define a service using a base URL and expected endpoints
export const userCRUDApi = createApi({
  reducerPath: 'userCRUDApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://backend.hira-tech.co.uk/',
    prepareHeaders: (headers, { getState }) => {
      // Get token from localStorage or from state if you store it there
      const token = localStorage.getItem('access_token');
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAllCustomers: builder.query({
      query: () => ({
        url: 'user/getAllcustomers/',
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
        },
      }),
    }),
    getAllStaff: builder.query({
      query: () => ({
        url: 'user/getAllstaff/',
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
        },
      }),
    }),
    getUser: builder.query({
      query: (id) => ({
        url: `user/Uprofile/${id}`,
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
        },
      }),
    }),
    getLoggedUser: builder.query({
      query: () => ({
        url: 'user/profile/',
        method: 'GET',
        // header not needed here; the prepareHeaders function already sets the token if present
      }),
    }),
    updateUser: builder.mutation({
      query: (user) => {
        const { id, ...rest } = user;
        return {
          url: `user/update/${id}`,
          method: 'PUT',
          body: rest,
          headers: {
            'Content-type': 'application/json',
          },
        };
      },
    }),
    deleteUser: builder.mutation({
      query: (id) => ({
        url: `user/delete/${id}`,
        method: 'DELETE',
        headers: {
          'Content-type': 'application/json',
        },
      }),
    }),
    getUserWithPermissions: builder.query({
      query: (id) => `user/${id}/permissions/`,
    }),

    updateStaffPermissions: builder.mutation({
      query: ({ id, allowed_pages }) => ({
        url: `user/${id}/permissions/update/`,
        method: 'PATCH',
        body: { allowed_pages },
      }),
    }),
  }),
});

export const {
  useGetAllCustomersQuery,
  useGetAllStaffQuery,
  useGetLoggedUserQuery,
  useGetUserQuery,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useGetUserWithPermissionsQuery,
  useUpdateStaffPermissionsMutation
} = userCRUDApi;